
const WordNetwork = require('./network')
const description = require('./keyword_network_description.html')

const NAME = '키워드 네트워크'

module.exports = {
    name: NAME,
    add: (analysis) => new WordNetwork(NAME, analysis, {onlyKeywords: true}),
    description: description,
}
